export default __webpack_public_path__ + "static/media/van.4675e5ac.png";